'use client';

import { Button as ButtonComponent, ButtonProps } from '@tajdid/tajdid-ui';

export default function Button({ size = 'large', ...rest }: ButtonProps) {
  return <ButtonComponent size={size} {...rest} />;
}
